<template>
    <div class="projects">
        <div class="container">
            <h1>Our Project</h1>
            <div class="row mt-5 mx-auto">
                <div v-for="project in projects" :key="project" class="col-12 col-md-6">
                    <img :src="project.porto" alt="" class="w-100 mt-4">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                projects :[
                    {
                        porto : require('../assets/img-project/Project 4.jpg')
                    },
                    {
                        porto : require('../assets/img-project/Project 1.jpg')
                    },
                    {
                        porto : require('../assets/img-project/Project 2.jpg')
                    },
                    {
                        porto : require('../assets/img-project/Project 3.jpg')
                    },
                ]
            }
        }
    }
</script>

<style scoped>
        
        .projects{
            margin-top: 100px;
            margin-bottom: 200px;
        }
        .projects h1{
            text-align: center;
            font-size: 3rem;
            font-weight: 700;
        }
        
        /* Responsive */
       /* Large Desktop */
       @media(min-width: 1200px){

       }
       /* Middle Desktop */
       @media(min-width: 1025px) and (max-width: 1199px){

       }
       /* Desktop */
        @media(min-width: 992px) and (max-width: 1024px){

        }
        /* Tablet */
        @media(min-width: 768px) and (max-width: 991px){
            
        }
        /* Handphone */
        @media(max-width: 767px){

        }
</style>